import React, { Suspense, lazy } from "react";
import { SECTIONS, sectionForPath } from "./sections";

const loaders = {
  messenger: lazy(() => import("./messenger/Messenger")),
  bafd: lazy(() => import("./apps/bafd/Entry")),
  records: lazy(() => import("./apps/records/Entry")),
  ics: lazy(() => import("./apps/ics/Entry")),
  training: lazy(() => import("./apps/training/Entry")),
  ppe: lazy(() => import("./apps/ppe/Entry")),
  access: lazy(() => import("./access/AccessAdmin")),
};

const Loading = () => (
  <div
    data-testid="section-loading"
    style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "sans-serif", color: "#888" }}
  >
    Loading...
  </div>
);

export default function App() {
  const section = sectionForPath(window.location.pathname);
  const Section = loaders[section.key];
  if (section.title) document.title = section.title;
  return (
    <Suspense fallback={<Loading />}>
      <Section basename={SECTIONS[section.key].prefix} />
    </Suspense>
  );
}
